const STORAGE_PREFIX = 'libertify.quickRecall.';

/** Removes the ratings earlier versions kept in `localStorage`; they are
 *  saved through the API now. SSR-safe and tolerant of blocked storage. */
export const clearLegacyMarks = (): void => {
  if (globalThis.localStorage === undefined) return;
  try {
    Object.keys(globalThis.localStorage)
      .filter((key) => key.startsWith(STORAGE_PREFIX))
      .forEach((key) => globalThis.localStorage.removeItem(key));
  } catch {
    /* ignore — storage is blocked, so there is nothing to remove */
  }
};
